export interface SharpRegion { x: number; y: number; w: number; h: number; scale: number }
/**
 * Region of the page (CSS px of the current viewport) to re-render crisply, or null if the full-page image
 * is already sharp. visible = the part of the page on screen; margin = fraction added around it if budget allows.
 */
export function sharpRegion(page: { w: number; h: number }, visible: { x: number; y: number; w: number; h: number }, baseScale: number, dpr: number, maxPixels: number, margin = 0.25): SharpRegion | null {
  if (baseScale >= dpr * 0.98) return null;
  const x0 = Math.max(0, visible.x), y0 = Math.max(0, visible.y);
  const x1 = Math.min(page.w, visible.x + visible.w), y1 = Math.min(page.h, visible.y + visible.h);
  if (x1 - x0 < 1 || y1 - y0 < 1) return null;
  const vw = x1 - x0, vh = y1 - y0;
  let scale = dpr;
  if (vw * vh * scale * scale > maxPixels) scale = Math.sqrt(maxPixels / (vw * vh));
  if (scale <= baseScale * 1.05) return null; // budget can't beat the base image
  // Grow the margin as far as the budget allows (up to `margin` on each side).
  let m = margin;
  const grow = (k: number) => { const mx = vw * k, my = vh * k; const ax = Math.max(0, x0 - mx), ay = Math.max(0, y0 - my); return { x: ax, y: ay, w: Math.min(page.w, x1 + mx) - ax, h: Math.min(page.h, y1 + my) - ay }; };
  let r = grow(m);
  while (m > 0 && r.w * r.h * scale * scale > maxPixels) { m = Math.max(0, m - 0.05); r = grow(m); }
  const x = Math.floor(r.x), y = Math.floor(r.y);
  return { x, y, w: Math.ceil(r.x + r.w) - x, h: Math.ceil(r.y + r.h) - y, scale };
}
